import React from 'react';
import { auth } from '../../../../../services';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { provideIntlService } from '@progress/kendo-react-intl';
import { PDFExport } from '@progress/kendo-react-pdf';
import './DownloadMembership.scss';
import domtoimage from 'dom-to-image';
import html2canvas from 'html2canvas';

class DownloadMembership extends React.Component {
	constructor(props) {
		super(props);
        this.state = {
            selectedMembership: this.props.accountDetails.selectedMember
        };
    };

    //createImage = () => {
        
    //        var node = document.getElementById('membershipCard');
    //        var img = new Image();
    //        console.log("node: " + node.innerHTML);
    //        domtoimage.toJpeg(node).then(dataUrl => {
    //            img.src = dataUrl;
    //            document.getElementById('membershipCardImage').replaceWith(img);
    //        }).catch(function (error) {
    //            console.error('oops, something went wrong!', error);
    //        });
    //}

    createImage = () => {
        var node = document.getElementById('membershipCard');
        html2canvas(document.querySelector("#membershipCard"), {
            backgroundColor: null
        }).then(canvas => {
            document.getElementById('membershipCardImage').appendChild(canvas);
        });
    }

    componentDidMount() {
        setTimeout(() => {
            this.createImage();
        }, 1000);
    }


    pdfExportComponent;

    render() {

		return (
			<div className="account-tab-content">
				<div>
					<div>
						<h1 className="pt-3 pb-3">Download Membership</h1>
                    </div>
                    <div key={this.state.selectedMembership.membershipId} className="membershipCard">
                        <div className="example-config">
                            <button
                                className="btnLink btn btn-sm btnPrimary" style={{ marginRight: "10px" }}
                                onClick={() => {
                                    this.pdfExportComponent.save();
                                }}
                            >
                                Download Membership Card
                            </button>
                        </div>
                        <div style={{ position: "absolute", left: "-5000px", top: "-5000px" }}>
                            <PDFExport
                                forcePageBreak=".page-break"
                                ref={(component) => this.pdfExportComponent = component}
                                paperSize="A4"
                                margin="0"
                                scale={.6}
                                landscape={true}
                            >
                                <div id="membershipCard">
                                    <div className="membershipFront">
                                        <div className="frontImageContainer"><img src="/images/Member-Card-2019-1.png" /></div>
                                        <div className="memberDtlContainer">
                                            <div className="memberDetails">
                                                <div className="row">
                                                    <div className="col-6">
                                                        Member Number: {this.state.selectedMembership.memberNumber}
                                                    </div>
                                                    <div className="col-6">
                                                        Full Name: {this.state.selectedMembership.fullName}
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6">
                                                        Join Date: {provideIntlService(this).formatDate(new Date(this.state.selectedMembership.joinDate), 'MM/d/y')}
                                                    </div>
                                                    <div className="col-6">
                                                        Renew Date: {provideIntlService(this).formatDate(new Date(this.state.selectedMembership.nextRenewDate), 'MM/d/y')}
                                                    </div>
                                                </div>
                                                {this.state.selectedMembership.organizationName != "" ?
                                                    <div className="row">
                                                        <div className="col-12">
                                                            Organization Name: {this.state.selectedMembership.organizationName}
                                                        </div>
                                                    </div>
                                                    : null}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="membershipBack page-break">
                                        <img src="/images/Member-Card-Back.png" />
                                    </div>
                                </div>
                            </PDFExport>
                        </div>
                        <div id="membershipCardImage">
                        </div>
                    </div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		details: state.accountDetails.details,
		getting: state.accountDetails.getting,
		memberships: state.accountDetails.myMemberships,
        common: state.common,
        accountDetails: state.accountDetails
	};
}

export default withRouter(
	connect(mapStateToProps, null)(DownloadMembership)
);
